import { render, staticRenderFns } from "./BasicTicket.vue?vue&type=template&id=51ce56e8&scoped=true"
import script from "./BasicTicket.vue?vue&type=script&lang=js"
export * from "./BasicTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ce56e8",
  null
  
)

export default component.exports